export enum MembershipGenderEnum {
  UNKNOWN = 'Unknown',
  MALE = 'Male',
  FEMALE = 'Female',
}

export enum MembershipUpdateEnumType {
  SUCCESS = 'Success',
  OTP_FAILED = 'OTPFailed',
  DUPLICATED_PHONE = 'DuplicatedPhone',
}

export enum MembershipUnlinkEnum {
  SUCCESS = 'Success',
  MEMBER_NOTFOUND = 'MemberNotFound',
}

export enum MembershipPromotionTypeEnum {
  COUPON = 'Coupon',
  POINT_REDEMPTION_FOR_COUPON = 'PointRedemptionForCoupon',
  POINT_REDEMPTION_WITH_PURCHASE = 'PointRedemptionWithPurchase',
}

export enum HHPointRedemptionFailureReasonEnum {
  NOT_ACTIVE = 'NotActive',
  NOT_YET_STARTED = 'NotYetStarted',
  INSUFFICIENT_POINTS = 'InsufficientPoints',
  MAX_REDEMPTION = 'MaxRedemption',
  MAX_REDEMPTION_PER_CUSTOMER = 'MaxRedemptionPerCustomer',
  EXPIRED = 'Expired',
}

export enum MemberCouponStatusEnumType {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  PENDING_START = 'PendingStart',
  REDEEMED = 'Redeemed',
}

export enum MembershipTierEnum {
  Friend = 'Friend',
  Family = 'Family',
  FoodPassionFriend = 'FoodPassionFriend',
  FoodPassionBuddy = 'FoodPassionBuddy',
  FoodPassionFamily = 'FoodPassionFamily',
}

export enum MemberCodeTypeEnum {
  qrcode = 'qrcode',
  barcode = 'barcode',
}
